import PdfChart from "@/routes/apt/[apt_code]/analysis/_components/bill-kpi/pdf/pdf-chart"

const PdfLayout = ({ info, xLabels, series }) => {
  return (
    <div className="w-[210mm] h-[297mm] relative bg-[#F7F9F8] overflow-hidden text-[#051937] font-['Pretendard']">
      <img className="w-full absolute top-0" src="/images/pdf/bg-top.png" alt="" />

      <main className="relative z-10 w-full h-full pt-10 px-5 flex flex-col">
        <section className="mb-3">
          <h1 className="text-[60px] font-extrabold leading-[1.1] tracking-[4px]">
            공동주택 검침
            <br />
            관리 안내문
          </h1>
          <p className="mt-2.5 mb-3 text-[18px] leading-5.5 font-600">
            저희 관리사무소는 <span className="text-[#6ca139] font-bold">세대별 공과금 절감</span>을
            위해 <br />
            실시간 데이터 분석을 통해 미세 옥내누수를 확인하였습니다.
          </p>
          <div className="w-3/4 h-0.5 bg-[#bec4d1]" />
        </section>

        <section className="flex flex-col gap-2">
          <header>
            <h2 className="pb-1.5 text-[24px] font-bold">
              {info.dong}동 {info.ho}호 옥내누수 분석 결과
            </h2>
            <div className="flex items-center gap-2">
              <div className="bg-[#041C3F] text-white px-3 py-1 rounded-2xl font-semibold flex items-center gap-1">
                <span>📌</span> 누수 의심 시작일
              </div>
              <p className="font-bold">
                <span className="text-[#B51E1F]">{info.leakStartAt.replace(/-/g, ".")}시</span> 이후
              </p>

              <p className="font-bold ml-auto">
                총 사용량: {info.usage}m³
                <span className="text-[#B51E1F] text-xs"> (+ {info.leak}m³)</span>
              </p>
            </div>
          </header>

          <article className="w-full h-60 border border-[#CBCDD2] rounded-md bg-white flex items-center justify-center text-gray-400">
            <PdfChart series={series} xLabels={xLabels} />
          </article>

          <article className="w-full flex gap-3 justify-center px-2 bg-[#F1F2F6] border border-[#A5B5CC] rounded-md padding-[18px_16px] py-4 text-center">
            <div className="w-2/5 flex items-center justify-center gap-2 mx-2">
              <img src="/images/pdf/fee-icon.png" className="w-20 h-auto" alt="" />
              <div className="">
                <h3 className="text-[18px] font-bold">현재 기준 예상 수도요금</h3>
                <h4 className="text-[44px] font-bold tracking-tighter">{info.totalBill}원</h4>
              </div>
            </div>

            <div className="border-l border-dotted border-[#A5B5CC]" />

            <div className="w-50">
              <h3 className="text-[18px] font-medium mb-1">손실 추가 요금</h3>
              <h4 className="text-[36px] font-bold text-[#B51E1F]">+{info.leakBill}원</h4>
              <p className="text-[14px]">(추가 발생 예상)</p>
            </div>

            <div className="border-l border-dotted border-[#A5B5CC]" />

            <div className="w-43">
              <h3 className="text-[18px] font-medium mb-1">수도 요금 증가율</h3>
              <h4 className="text-[36px] font-bold text-[#B51E1F]">+{info.billPercent}%</h4>
              <p className="text-[14px]">(손실 대비 요금)</p>
            </div>
          </article>

          <article className="w-full min-h-50">
            <img src="/images/pdf/self-short.png" className="w-full h-auto rounded-xl" alt="" />
          </article>

          <article className="flex items-center gap-3 font-semibold">
            <div className="w-7 h-7 rounded-full bg-[#041C3F] text-white flex items-center justify-center text-xl shrink-0">
              i
            </div>
            <div className="text-[15px]">
              <p>위 내용은 참고용으로, 다소 차이가 있을 수 있습니다.</p>
              <p>
                정확한 진단과 조치를 원하시면 <span className="text-[#B51E1F]">관리사무소</span>{" "}
                또는 <span className="text-[#B51E1F]">1551-2868</span>로 연락주세요.
              </p>
            </div>
          </article>
        </section>

        <footer
          id="pdf-ready"
          className="absolute bottom-0 left-0 w-full flex justify-center items-center text-white gap-2"
        >
          <div className="absolute bg-[#BBCF76] w-full h-2 bottom-10 -z-1" />
          <div className="absolute bg-[#031738] w-full h-12 -z-1" />
          <img src="/images/pdf/apt-icon.png" className="w-8" alt="" />
          <p className="text-xl font-medium">
            {info.apt} 관리소장 <span className="text-xs">(직인 생략)</span>
          </p>
        </footer>
      </main>
      <div id="pdf-ready" />
    </div>
  )
}

export default PdfLayout
